<template>
  <div v-if="!!uploadUrl">
    <v-card outlined rounded="lg">
      <v-card-title> Compartilhar link com paciente para envio de imagens </v-card-title>
      <v-container>
        <v-row justify="start">
          <v-col cols="2" class="text-center">
            <v-btn :disabled="disabled" x-large icon target="_blank" color="primary" @click="copyToClipboard">
              <v-icon x-large>mdi-link</v-icon>
            </v-btn>
            <p class="mb-0">Copiar link</p>
          </v-col>
          <v-col cols="2" class="text-center">
            <v-btn x-large icon :disabled="!patientMobile || disabled" :href="whatsappLink" target="_blank" color="primary">
              <v-icon x-large>mdi-whatsapp</v-icon>
            </v-btn>
            <p class="mb-0">Compartilhar<br />por WhatsApp<br />{{ patientMobile }}</p>
          </v-col>
          <v-col cols="2" class="text-center">
            <v-btn
              x-large
              icon
              :disabled="!patientMobile || smsCooldown || disabled"
              target="_blank"
              color="primary"
              @click="sendSms"
            >
              <v-icon x-large>mdi-message-processing</v-icon>
            </v-btn>
            <p class="mb-0">Enviar por SMS<br />{{ patientMobile }}</p>
            <small v-if="smsCooldown">Aguarde {{ resendSmsSeconds }}s para poder enviar novamente</small>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
  <v-sheet v-else>
    <h1>
      Este atendimento foi gerado sem a possibilidade de enviar imagens.
      <br />
      Se você acredita que isto é um erro, entre em contato com o Suporte.
    </h1>
  </v-sheet>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: newAttendanceFormGetters } = createNamespacedHelpers('newAttendanceForm')

export default {
  data() {
    return {
      smsCooldown: false,
      resendSmsSeconds: 60,
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...newAttendanceFormGetters(['attendance', 'extraAnswers']),
    uuid() {
      return this.attendance.patient.uuid
    },
    patientId() {
      return this.attendance.patient.id
    },
    patientMobile() {
      return this.attendance.patientMobile
    },
    uploadUuid() {
      return this.attendance?.uploadPhotoUuid
    },
    attendanceId() {
      return parseInt(this.attendance.id)
    },
    uploadUrl() {
      if (!this.uploadUuid) {
        return null
      }
      return `${window.location.origin}/upload-attendance-photo?u=${this.uuid}&a=${this.attendanceId}`
    },
    whatsappLink() {
      if (!this.uploadUrl || !this.patientMobile) {
        return null
      }
      const mobileNumber = this.$util.toNumbersOnly(this.patientMobile)
      const message = this.$util.urlEncode(`Envie fotos ao seu médico em ${this.uploadUrl}`)
      return `https://api.whatsapp.com/send?phone=55${mobileNumber}&text=${message}&lang=pt_br`
    },
  },
  methods: {
    copyToClipboard() {
      this.$util.copyToClipboard(this.uploadUrl)
      this.$root.info('Link copiado para a área de transferência')
    },
    async sendSms() {
      try {
        this.smsCooldown = true
        await this.$api.sendSmsUploadPhoto(this.attendanceId)
        setTimeout(() => (this.smsCooldown = false), this.resendSmsSeconds * 1000)
      } catch (error) {
        this.smsCooldown = false
        this.$root.error(error)
      }
    },
  },
}
</script>

<style scoped>
.border-gray {
  border: 1px solid #e6e6e6;
}
</style>
